module.exports = __webpack_public_path__ + "static/media/kuantoKusta.e782de9e.svg";